var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",style:(_vm.vsize),attrs:{"aria-hidden":"true"},on:{"click":_vm.emitClick}},[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }